<template>
  <div>
    <el-select v-model="viewType" placeholder="Select">
      <el-option
          v-for="item in viewTypeOptions"
          :key="item.label"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
    <br/>
    <br/>
    <el-table :data="documents" size="mini" border style="margin-bottom: 20px">
      <el-table-column :min-width="65">
        <template slot-scope="scope">
          <div :class="getSubFileClass(scope.row.sub_file)">
            <h5 :id="id_generator(scope.row.display_name)" v-if="scope.row.sub_file == false">
              {{ scope.row.display_name }}<span v-if="scope.row.display_name == 'Full CV' && !eCheckListFlag"
                                                style="color: #003366; font-size: 30px">*</span>
              <el-popover
                  placement="top-start"
                  width="500"
                  trigger="hover"
                  :content="itemDescription.presentationTalkDescription"
                  v-if="scope.row.display_name == 'Presentation Talk (video)'">
                <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>
              </el-popover>
                <el-popover
                    placement="top-start"
                    width="500"
                    trigger="hover"
                    :content="itemDescription.recommendationReport"
                    v-if="scope.row.display_name == 'Thrust Search and Substantiation Committee (Thrust SSC) Recommendation Report'">
                  <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>
              </el-popover>
              <el-popover
                  placement="top-start"
                  width="500"
                  trigger="hover"
                  :content="itemDescription.refereeLetterDesc"
                  v-if="scope.row.display_name == 'Reference Letter'">
                <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>
              </el-popover></h5>
            <span v-else>{{ scope.row.display_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Operation" style="align-items: center" :min-width="20" width="180"
                       label-class-name="table-label-class">
        <template slot-scope="scope">
          <UploadComponent
              v-if="uploadFileDisplay(scope)"
              :cid="cid"
              :e-check-list-flag="eCheckListFlag"
              :desc-display=false
              :name="getUploadFileName(scope)"
              :desc="scope.row.display_name"
              :serverFilename="scope.row.filename"
              :index="getIndex(scope)"
              :referee="scope.row.refereeID"
              :submitted="getSubmittedData(scope.row)"
              :download-flag="viewType"
              :fileLimit="scope.row.size_limit"
              :fileType="scope.row.file_type"
              :downloadFilename="applicantName+'_'+scope.row.display_name"
              :button-size="'mini'"
              :currentApplicantId="applicantId"
              v-on:fileDataUpdate="fileDataHandler" v-on:viewFile="showFile"
              v-on:downloadFile="downloadFile"></UploadComponent>
        </template>
      </el-table-column>
      <el-table-column label="Last Updated" :min-width="15" label-class-name="table-label-class">
        <template slot-scope="scope">
          <span v-if="scope.row.time !== ''"><div class="table-label-class">{{ scope.row.time }}</div></span>
        </template>
      </el-table-column>
    </el-table>
    <div class="center-div" v-if="addRowRightCheck()">
      <el-button @click="addRowFlag = true">Add row</el-button>
    </div>
    <el-dialog
        append-to-body
        title="Pdf Viewer"
        :visible.sync="centerDialogVisible"
        v-if="centerDialogVisible"
        width="80%"
        center>
      <!--      <iframe :src="file_src" frameborder="0" style="width: 100%; height: 500px"></iframe>-->
      <!--      <pdf :src="file_src" style="width: 100%; height: 500px; overflow: scroll"></pdf>-->
      <div style="overflow-y: auto">
        <pdf
            v-for="i in numPages"
            :key="i"
            :src="file_src"
            :page="i"
            style="height: 100%"
        ></pdf>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="closeIframe">Cancel</el-button>
          <el-button type="primary" @click="closeIframe">OK</el-button>
      </span>
    </el-dialog>
    <el-dialog
        append-to-body
        title="Video Viewer"
        :visible.sync="centerDialogVisibleVideo"
        v-if="centerDialogVisibleVideo"
        width="80%"
        center>
      <video loop autoplay controls playsInline style="width: 100%; height: 500px;" :src="file_src">
        <source :src="file_src" type="video/mp4">
      </video>
      <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisibleVideo = false">Cancel</el-button>
          <el-button type="primary" @click="centerDialogVisibleVideo = false">OK</el-button>
      </span>
    </el-dialog>
    <el-dialog
        append-to-body
        title="Video Viewer(Only for mp4)"
        :visible.sync="centerDialogVisibleVideoIframe"
        v-if="centerDialogVisibleVideoIframe"
        width="80%"
        center>
      <iframe :src="file_src" frameborder="0" style="width: 100%; height: 500px"></iframe>
      <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisibleVideoIframe = false">Cancel</el-button>
          <el-button type="primary" @click="centerDialogVisibleVideoIframe = false">OK</el-button>
      </span>
    </el-dialog>
    <el-dialog
        append-to-body
        title="Add new File (New file will be valid after updating)"
        :visible.sync="addRowFlag"
        v-if="addRowFlag"
        width="50%"
        center>
      <div>
        <span style="color: red">caution: File cannot be delete after update, contact system admin if a file is accidentally added</span>
        <el-input v-model="localRowObject.display_name"></el-input>
        <el-button style="margin-top:20px" @click="addRow()">Add File</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fileHandlerMixin from "@/components/view/js/fileHandlerMixin";
import UploadComponent from "@/basic_components/UploadComponent";
import pdf from "vue-pdf";
import {Message} from "element-ui";
import eCheckListUploadFileNameRestriction from "@/assets/json/eCheckListUploadFileNameRestriction.json";
import eCheckListRole from "@/assets/json/eCheckListRole.json"
import description from "@/assets/json/description.json";

export default {
  name: "ScreeningDocumentComponent",
  mixins: [fileHandlerMixin],
  data() {
    return {
      itemDescription: description,
      localECheckListRole: eCheckListRole,
      localECheckListUploadFileNameRestriction: eCheckListUploadFileNameRestriction,
      viewTypeOptions: [
        {
          value: false,
          label: 'View File'
        },
        {
          value: true,
          label: 'Download File'
        }
      ],
      localRowObject: {
        display_name: "",
        file_type: ["pdf"],
        filename: "",
        size_limit: 10,
        parent: false,
        sub_file: false,
        submitted: false,
        time: ""
      },
      addRowFlag: false,
      viewType: false
    }
  },
  components: {
    UploadComponent,
    pdf
  },
  props: {
    subFileClass: {
      type: String,
      default: ''
    },
    eCheckListRight: {
      type: Array,
      default: () => []
    },
    cid: {
      type: String,
      default: ''
    },
    eCheckListLock: {
      type: Boolean,
      default: true
    },
    screeningUploadFileRights: {
      type: Array,
      default: () => []
    },
    documents: {
      type: Array,
      default: () => []
    },
    applicantName: {
      type: String,
      default: ''
    },
    uid: {
      type: String,
      default: ''
    },
    originalDocuments: {
      type: Array,
      default: () => []
    },
    applicantId: {
      type: String,
      default: undefined
    },
    applicantStatus: {
      type: String,
      default: ""
    }
  },
  created() {
    if (this.screeningUploadFileRights.includes(this.uid)) {
      // this.originalDocuments.forEach((element)=>{
      //   element.submitted = false
      // })
      this.documents = [...this.originalDocuments]
    }
    console.log(this.originalDocuments)
  },
  methods: {
    getSubFileClass(subFileFlag){
      if(subFileFlag){
        return this.subFileClass
      }
    },
    addRowRightCheck() {
      if (this.eCheckListFlag && (this.eCheckListRight.includes(this.localECheckListRole.thrustAdmin) || this.eCheckListRight.includes(this.localECheckListRole.hubAdmin)
          || this.eCheckListRight.includes(this.localECheckListRole.systemAdmin))) {
        return true
      }
      return false
    },
    addRow() {
      if (this.localRowObject.display_name == "") {
        Message({
          message: "Name of the file cannot be empty",
          type: "error"
        })
        return
      }
      for (let i = 0; i < this.documents.length; i++) {
        if (this.documents[i].display_name == this.localRowObject.display_name) {
          Message({
            message: "New file name cannot be the same as any of the previous file",
            type: "error"
          })
          return
        }
      }
      this.documents.push(this.localRowObject)
      Message({
        message: "Click Update to save new files",
        type: "success",
        duration: 10000,
        showClose: true
      })
      this.localRowObject = {
        display_name: "",
        file_type: ["pdf"],
        filename: "",
        size_limit: 10,
        parent: false,
        sub_file: false,
        submitted: false,
        time: ""
      }
      this.addRowFlag = false
    },
    id_generator(id) {
      return id.toString().replace(/\s+/gi, '_').replace(/\W/g, '').toLowerCase()
    },
    closeIframe() {
      this.centerDialogVisible = false
    },
    getUploadFileName(scope) {
      if (Object.prototype.hasOwnProperty.call(scope.row, "refereeID")) {
        return "reference_letter"
      } else {
        return this.id_generator(scope.row.display_name)
      }
    },
    getIndex(scope) {
      if (Object.prototype.hasOwnProperty.call(scope.row, "refereeID")) {
        return 0
      } else {
        return scope.$index
      }
    },
    // rewrite update function
    getSubmittedData(row) {
      if (this.screeningUploadFileRights.includes(this.uid)) {
        if (this.viewType) {
          return row.submitted
        } else {
          return false
        }
      } else if (this.eCheckListFlag) {
        if (row.filename) {
          return true
        } else {
          return false
        }
      } else {
        return row.submitted
      }
    },
    fileDataHandler(name, time, desc, operation) {
      // for object additional in vue contention, otherwise vue will not react
      console.log('name ' + name)
      // this.$set(this.templateData[name], 'time', time)
      this.updateDocument(name, time, desc, operation)
      if (operation == 'upload') {
        Message({
          message: "File uploaded",
          type: "success"
        })
      } else if (operation == 'delete') {
        Message({
          message: "File Deleted!",
          type: "success"
        })
      }
      this.$emit('updatePersonalData')
    },
    updateDocument(name, time, desc, operation) {
      for (let i = 0; i < this.documents.length; i++) {
        if (this.documents[i].display_name == desc) {
          this.$set(this.documents[i], 'filename', name)
          this.$set(this.documents[i], 'time', time)
          if (this.applicantStatus === "submitted") {
            if (operation === 'upload') {
              this.$set(this.documents[i], 'submitted', true)
            } else if (operation === "delete") {
              this.$set(this.documents[i], 'submitted', false)
            }
          }
          break
        }
      }
    },
    getECheckListFileName(name) {
      if (name.includes("DEPENDENT Letter")) {
        return "DEPENDENT Letter #"
      } else if (name.includes("INDEPENDENT Letter")) {
        return "INDEPENDENT Letter #"
      } else {
        return name
      }
    },
    eCheckListRolesCheck(rights, name, fileName) {
      let eCheckListRights = require("../components/view/js/eCheckListRights")
      if (name != "") {
        return true
      } else {
        if (!eCheckListRights().hasOwnProperty(this.getECheckListFileName(fileName))) {
          return true
        }
        for (let i = 0; i < eCheckListRights()[this.getECheckListFileName(fileName)].length; i++) {
          if (rights.includes(eCheckListRights()[this.getECheckListFileName(fileName)][i])) {
            return true
          }
        }
        return false
      }
    },
    uploadFileDisplay(scope) {
      if (scope.row.sub_file || (!scope.row.sub_file && !scope.row.parent)) {
        if (this.screeningUploadFileRights.includes(this.uid)) {
          return true
        } else if (this.eCheckListFlag) {
          if (this.eCheckListLock) {
            // console.log(scope.row)
            return this.eCheckListRolesCheck(this.eCheckListRight, scope.row.filename, scope.row.display_name)
            // return true
          } else {
            if (this.localECheckListUploadFileNameRestriction.includes(scope.row.display_name) && !this.getSubmittedData(scope.row)) {
              return false
            } else {
              return this.eCheckListRolesCheck(this.eCheckListRight, scope.row.filename, scope.row.display_name)
              // return true
            }
          }
        } else {
          if (scope.row.filename) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
@import "../components/view/css/center.css";

.sub-file-class{
  font-size: 13px;
}
</style>
